import React, { createContext, useCallback, useContext } from 'react';
import { openWhatsApp } from '../utils/whatsapp';
import { trackWhatsAppLead } from '../utils/analytics';
export interface WhatsAppRequest {
  message: string;
  location: string;
  intent?: string;
}
interface WhatsAppGateValue {
  /** Punto único de salida a WhatsApp: dispara Lead y abre el chat directo, sin pasos intermedios. */
  requestWhatsApp: (request: WhatsAppRequest) => void;
}
const WhatsAppGateContext = createContext<WhatsAppGateValue | null>(null);
export function WhatsAppGateProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const requestWhatsApp = useCallback((request: WhatsAppRequest) => {
    trackWhatsAppLead(request.location, request.intent ?? 'cotizacion');
    openWhatsApp(request.message);
  }, []);
  return <WhatsAppGateContext.Provider value={{
    requestWhatsApp
  }} data-id="element-301" data-mp="s4e2tqphnhmu">{children}</WhatsAppGateContext.Provider>;
}
export function useWhatsAppGate(): WhatsAppGateValue {
  const ctx = useContext(WhatsAppGateContext);
  if (!ctx) throw new Error('useWhatsAppGate debe usarse dentro de WhatsAppGateProvider');
  return ctx;
}